import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormLabel, IconButton, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useScreenSize, ScreenSizeEnum } from "shared/use-screen-size";
import CloseIcon from "@mui/icons-material/Close";
import { FormDialogProps } from "shared/dialog/types";
import { useForm } from "react-hook-form";

export interface CreateListFormData {
  name: string;
}

interface Props extends FormDialogProps<CreateListFormData> {}

export const CreateListDialog = (props: Props) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenSize();

  const { getValues, setValue, watch } = useForm<CreateListFormData>({
    mode: "all",
    defaultValues: {
      name: "",
    },
  });

  const nameValue = watch("name");

  const handleSubmit = () => {
    props.onSubmit(getValues());
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          height: screenSize === ScreenSizeEnum.Mobile ? "100%" : "750px", // mobile is ignored
          margin: screenSize === ScreenSizeEnum.Mobile ? "32px 7px" : "32px",
          width: screenSize === ScreenSizeEnum.Mobile ? "100%" : "calc(100´%-64px)",
        },
      }}
      open={props.isOpen}
    >
      <DialogTitle component="div" textAlign={"center"} p={0}>
        <Typography variant="h5" color="primary.dark">
          {t("account.favorites.createListDialogTitle")}
        </Typography>
        <IconButton onClick={props.onClose} sx={{ position: "absolute", top: 0, right: 0 }}>
          <CloseIcon />
        </IconButton>
        <Divider sx={{ marginTop: 2 }} />
      </DialogTitle>

      <DialogContent sx={{ padding: 2 }}>
        <FormLabel sx={{ mb: 1 }}>{t("account.favorites.createListDialogLabel")}</FormLabel>
        <TextField fullWidth variant="outlined" value={nameValue} onChange={(e) => setValue("name", e.target.value)} sx={{ mt: 1 }} />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={props.onClose}>
          {t("common.cancel")}
        </Button>
        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={!getValues("name")?.trim()}>
          {t("common.add")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
